import React from 'react';
import { Modal, Input, Button } from 'antd';
import { UserOutlined, SaveOutlined } from '@ant-design/icons';
import { ContactModalProps } from '@/types/TTextingPlatform';

const ContactModal: React.FC<ContactModalProps> = ({
	visible,
	onClose,
	contactValue,
	setContactValue,
	onSave,
	themeColor,
}) => {
	const handleSave = () => {
		if (!contactValue.trim()) {
			return;
		}
		onSave();
	};

	const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			handleSave();
		}
	};

	return (
		<Modal
			title={
				<div className="flex items-center gap-2">
					<UserOutlined className="text-blue-600" />
					<span>Create Contact</span>
				</div>
			}
			open={visible}
			onCancel={onClose}
			footer={null}
			centered
			width={400}
		>
			<div className="py-4">
				<div className="mb-4">
					<label className="block text-sm font-medium text-gray-700 mb-2">Contact Name</label>
					<Input
						placeholder="John Doe"
						value={contactValue}
						onChange={(e) => setContactValue(e.target.value)}
						onKeyPress={handleKeyPress}
						size="large"
						autoFocus
					/>
				</div>

				<div className="flex justify-end gap-2">
					<Button onClick={onClose}>Cancel</Button>
					<Button
						type="primary"
						icon={<SaveOutlined />}
						onClick={handleSave}
						disabled={!contactValue.trim()}
						style={{
							backgroundColor: themeColor,
							borderColor: themeColor,
						}}
					>
						Create Contact
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default ContactModal;
